<template>
  <div v-if="inputedValue.dialog && pageData.length > 0">
    <OrderIncompleteDialogBase
      v-model="inputedValue"
      :title="title"
      :width="width"
      :pageData="pageData"
      :rec-items="recItems"
      @complete="complete"
      isCardColor="true"
    >
      <template v-slot:[pageData[1].name]="{ item }">
        <div>
          <IncompleteNotificationHistoryTable
            v-if="pageData[1].items && pageData[1].items.length > 0"
            :headers="pageData[1].headers"
            :propsItems="pageData[1].items"
            :item-key="pageData[1].itemKey"
            :recItems="recItems"
            @complete="complete"
          ></IncompleteNotificationHistoryTable>
        </div>
      </template>
      <template v-slot:[pageData[2].name]="{ item }">
        <OperationDetail :recItems="recItems" type="sale" />
      </template>
    </OrderIncompleteDialogBase>
  </div>
</template>

<script>
import OperationDetail from '@/components/layouts/OperationDetail/OperationDetail'
import OrderIncompleteDialogBase from '@/components/layouts/Dialogs/MultipleArea/OrderIncompleteDialog/OrderIncompleteDialogBase'
import { mapActions } from 'vuex'
import IncompleteNotificationHistoryTable from '@/components/items/Tables/IncompleteNotificationHistoryTable'

export default {
  name: 'OrderIncompleteDialog',
  components: {
    IncompleteNotificationHistoryTable,
    OrderIncompleteDialogBase,
    OperationDetail
  },
  props: {
    value: { default: false },
    width: { default: '540px' },
    title: { default: '' },
    recItems: {
      type: Object,
      require: false,
      default: () => ({})
    }
  },
  data: () => ({
    pageData: []
  }),
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  created() {
    this.ini()
  },
  watch: {
    inputedValue: {
      deep: true,
      async handler(newVal, oldVal) {
        if (newVal.dialog) await this.ini()
      }
    }
  },
  methods: {
    ...mapActions('Sale', ['getOrderIncompleteListFromApi']),
    async ini() {
      const orderIncompleteList = await this.getOrderIncompleteListFromApi({
        saleId: this.recItems.saleId
      })
      this.pageData = [
        {
          title: 'order.order_incomplete-notification',
          name: 'orderIncompleteNotification '
        },
        {
          title: 'sale.shipping_history',
          name: 'shippingHistory ',
          buttonName: 'common.input_order-send',
          itemKey: 'shipId',
          headers: [
            {
              text: 'ship.ship_notification-date',
              value: 'created_at_formatted',
              sortable: false,
              width: '12%'
            },
            {
              text: 'ship.ship_sender',
              value: 'user.fullName',
              sortable: false,
              width: '12%'
            },
            {
              text: 'ship.ship_incomplete-order-reason',
              value: 'orderReason',
              sortable: false,
              width: '12%'
            },
            {
              text: 'ship.ship_remarks-column',
              value: 'content',
              width: '30%',
              sortable: false
            },
            {
              text: 'sale.sale_status',
              value: 'status',
              sortable: false
            },
            {
              text: '',
              value: 'id',
              sortable: false,
              width: '12%'
            }
          ],
          items: orderIncompleteList
        },
        {
          title: 'common.input_sale-details',
          name: 'salesDetail'
        }
      ]
    },
    complete() {
      this.$emit('complete')
    }
  }
}
</script>

<style scoped></style>
